import axios, {AxiosError, HttpStatusCode, isAxiosError} from 'axios'

import {Status} from '../constants/response'

export type NetworkError = {
    code: 'ERR_NETWORK'
}

export const isNetworkError = (error: unknown): error is NetworkError => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error as any)?.code === 'ERR_NETWORK'
}

export const isMaintenanceError = (error: unknown) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error as any)?.status === HttpStatusCode.ServiceUnavailable
}

export const isMaintenanceAxiosError = (error: unknown): error is AxiosError => {
    if (isAxiosError(error)) {
        return (
            error.response?.status === Status.SERVICE_UNAVAILABLE ||
            error.response?.status === Status.SERVICE_IS_OVERLOADED
        )
    }
    return false
}

/**
 * 존재하지 않는 api 주소가 호출되어 호출실패했거나,
 * BFF에서 ApigwResponse로 정의되지 않은 에러가 리턴된 케이스.
 * BFF에서 사전 정의한 에러라면 response.data.code가 @web/core/constants/ApigwResponse 중 하나로 정의되어있음.
 */
export const isUnexpectedGatewayError = (err: unknown): boolean => {
    return isNetworkError(err) || (isAxiosError(err) && !err?.response?.data?.code)
}

export const isApiError = isAxiosError

export const isApiErrorWithType = <ResponseDataType>(error: unknown): error is AxiosError<ResponseDataType> => {
    return isApiError(error)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isPredefinedApiError = <T = {code: string; message: string}, D = any>(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: AxiosError<any, any>,
    fields: string[] = ['code', 'message'],
): error is AxiosError<T, D> => {
    return fields.some((field) => error.response && field in error.response.data)
}

/**
 * 취소 토큰을 이용해 요청을 취소할 수 있습니다.
 * @sse https://axios-http.com/kr/docs/cancellation
 **/
export const getCancelToken = () => {
    return axios.CancelToken.source()
}
